import { Navigate, useLocation } from 'react-router-dom';
import Path, { GUEST_RESERVATION_SCREENS } from 'constants/routePath';
import DefaultRoute from './defaultRoute';
import DefaultRouteGuest from './defaultRouteGuest';

const BeforeLoginRoute = ({ isLogin }) => {
  const location = useLocation();

  // ログイン時に遷移する画面
  const afterLogin = {
    [Path.DESCRIPTION]: Path.TOP,
    [Path.KARTE_DESCRIPTION]: Path.KARTE,
  };

  const to = afterLogin[location.pathname];

  if (GUEST_RESERVATION_SCREENS.includes(location.pathname)) {
    return <DefaultRouteGuest isLogin={isLogin} />;
  }

  return !isLogin ? (
    <DefaultRoute />
  ) : (
    <Navigate replace to={to} state={location.state} />
  );
};

export default BeforeLoginRoute;
